import { supabase } from '../../lib/supabase';
import type { AdminRow } from '../../lib/types';

export async function listAdmins(): Promise<AdminRow[]> {
  const { data, error } = await supabase.from('admins').select('user_id, email, created_at, created_by').order('created_at', { ascending: true });
  if (error) throw error;
  return (data ?? []) as AdminRow[];
}

/** admin_grant(p_email) -- admin-only RPC; raises 'no Calyard account uses %' (P0002) when nobody has signed up with that email. */
export async function grantAdmin(email: string): Promise<string> {
  const { data, error } = await supabase.rpc('admin_grant', { p_email: email });
  if (error) throw error;
  return data as string;
}

/** admin_revoke(p_user) -- admin-only RPC; raises when revoking yourself or the last admin. */
export async function revokeAdmin(userId: string): Promise<void> {
  const { error } = await supabase.rpc('admin_revoke', { p_user: userId });
  if (error) throw error;
}
